import { useMemo } from 'react'
import { isRequesting, isSuccessWithData, useFirebase } from 'src/firebase/useFirebase'
import { joinName } from '../format'

export type CoachOption = { id: string; name: string }

type CoachProfileShape = { firstname?: string; lastname?: string; isSuspended?: boolean }
type CoachProfilesShape = Record<string, CoachProfileShape>

export const useCoachRosterState = (): { coaches: CoachOption[]; loading: boolean } => {
  const request = useFirebase<CoachProfilesShape>('coachProfiles')

  const coaches = useMemo(() => {
    if (!isSuccessWithData(request)) {
      return []
    }

    return Object.entries(request.data)
      .filter(([, profile]) => !profile.isSuspended)
      .map(([id, profile]) => ({ id, name: joinName(profile.firstname, profile.lastname) || id }))
      .sort((a, b) => a.name.localeCompare(b.name))
  }, [request])

  return { coaches, loading: isRequesting(request) }
}

export const useCoachRoster = (): CoachOption[] => useCoachRosterState().coaches
